export default __webpack_public_path__ + "static/media/thumbnail-podcast.c7ae4f36.png";